import { AddStoryDiscussionCommentMeta, AddStoryDiscussionCommentPayload } from 'types/store/AddStoryDiscussionComment';
import { createAsyncReducer } from 'utils/Redux';

import { addStoryDiscussionCommentActions } from '../actions';

export default createAsyncReducer<AddStoryDiscussionCommentMeta, AddStoryDiscussionCommentPayload>(addStoryDiscussionCommentActions);
